<template>
  <div>
  <Navbar/>
  <div class="background pt-2">
    <SeletorData class="seletor" v-model="diaSelecionado"></SeletorData>
    <div class="palestras">
      <ButtonFill @click="onClickAdd" texto="Adicionar palestra" />
      <CardPalestra
        v-for="palestra in palestras"
        v-bind:key="palestra.id"
        :palestra="palestra"
        admin="true"
        style="margin-bottom: 15px;"
        @excluir="onClickExcluir"
      ></CardPalestra>
      <b-modal
        id="modal-excluir"
        title="Excluir palestra"
        ok-title="Excluir"
        ok-variant="danger"
        cancel-title="Cancelar"
        @ok="onExcluir(palestraSelecionada)"
      >Deseja excluir a palestra '{{ palestraSelecionada.title }}'?</b-modal>
    </div>
  </div>
  </div>
</template>

<script>
import SeletorData from "@/components/SeletorData.vue";
import CardPalestra from "@/components/CardPalestra.vue";
import ButtonFill from "@/components/Button-fill.vue";
import Navbar from '@/components/Navbar-user.vue';
import { listarPalestras, excluirPalestra } from "@/services/api/Palestra";
export default {
  components: {
    SeletorData,
    CardPalestra,
    ButtonFill,
    Navbar,
  },
  data() {
    return {
      palestras: [],
      palestraSelecionada: {},
      diaSelecionado: undefined
    };
  },
  methods: {
    onClickAdd() {
      this.$router.push("/admin/adicionar-palestra");
    },
    onClickExcluir(palestra) {
      this.$bvModal.show("modal-excluir");
      this.palestraSelecionada = palestra;
    },
    onExcluir(palestra) {
      excluirPalestra(palestra._id)
        .then(() => {
          this.$router.go();
        })
        .catch(err => {
          console.error("Error deleting palestra", err.response);
          alert("Erro ao excluir palestra");
        });
    }
  },
  watch: {
    diaSelecionado() {
      listarPalestras(this.diaSelecionado).then(res => {
        this.palestras = res.data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.background {
  margin-top: 10vh;
  background-color: #fcfcfc;
  font-family: Roboto;
  height: 100vh;
  width: 100%;
}

.palestras {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.seletor {
  margin-top: 2rem;
  margin-bottom: 2rem;
}
</style>
